import cleaningImg from "@/assets/cleaning-service.jpg";
import plumbingImg from "@/assets/plumbing-card.jpg";
import childcareImg from "@/assets/childcare-service.jpg";
import tutoringImg from "@/assets/tutoring-service.jpg";
import maintenanceImg from "@/assets/home-maintenance.jpg"; // perf-fix: was 1.9MB PNG
import elderlyCareImg from "@/assets/elderly-care-service.jpg";
import cookingImg from "@/assets/cooking-card.jpg";
import gardeningImg from "@/assets/garden-maintenance.jpg";
import laundryImg from "@/assets/laundry-card.jpg";
import petCareImg from "@/assets/pet-care-service.jpg";
import movingImg from "@/assets/moving-service.jpg";
import beautyImg from "@/assets/beauty-salon-service.jpg";
import carWashImg from "@/assets/car-wash-card.jpg";
import eventHelpImg from "@/assets/event-help-card.jpg";
import securityImg from "@/assets/security-guard.jpg";

/**
 * Bundled fallback pictures for categories whose `service_categories` row has
 * no `image_url`, keyed by catalogue slug. One table for every page that shows
 * a category picture (#781), so a slug added here is picked up everywhere.
 */
const CATEGORY_IMAGES: Record<string, string> = {
  "house-cleaning": cleaningImg,
  "childcare": childcareImg,
  "plumbing": plumbingImg,
  "tutoring": tutoringImg,
  "electrical": maintenanceImg,
  "elderly-care": elderlyCareImg,
  "cooking": cookingImg,
  "gardening": gardeningImg,
  "laundry": laundryImg,
  "pet-care": petCareImg,
  "moving": movingImg,
  "handyman": maintenanceImg,
  "beauty": beautyImg,
  "car-wash": carWashImg,
  "event-help": eventHelpImg,
  "security": securityImg,
};

/** The admin-set image when there is one, else the bundled fallback, else "". */
export function categoryImage(slug: string, imageUrl?: string | null): string {
  return imageUrl || CATEGORY_IMAGES[slug] || "";
}
